import { Directive, output, input } from '@angular/core';

import type { InsertPlaceholderInputDirective } from './insert-placeholder-input.directive';

@Directive({
  standalone: true,
  selector: '[insertPlaceholder]',
  host: {
    '(mousedown)': 'insert($event)',
  },
})
export class InsertPlaceholderDirective {
  public readonly placeholder = input<string>(undefined!, { alias: 'insertPlaceholder' });
  public readonly target = input<InsertPlaceholderInputDirective>(undefined!, {
    alias: 'insertPlaceholderTarget',
  });
  public readonly disabled = input<boolean>(false);

  public mouseDown = output<MouseEvent>();

  public insert($event: MouseEvent): void {
    if (this.disabled()) {
      $event.stopPropagation();
      $event.preventDefault();
      return;
    }
    const target = this.target();
    if (target) {
      $event.stopPropagation();
      $event.preventDefault();
      target.insert(this.placeholder());
    }
    this.mouseDown.emit($event);
  }
}
